import type { AppState3dsType } from '@onramp/shared/appState3ds.schema';
import { atom } from 'jotai';

export const appState3dsAtom = atom<AppState3dsType | undefined>(undefined);
